(() => {
  if (customElements.get('diarist-contact-form')) return;

  class DiaristContactForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.subject = this.querySelector('[data-contact-subject]');
      if (!this.form || !this.subject || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.orderGroup = this.querySelector('[data-contact-order]');
      this.designGroup = this.querySelector('[data-contact-design]');
      this.orderInput = this.querySelector('[data-contact-order-input]');
      this.link = this.querySelector('[data-contact-link]');
      this.access = this.querySelector('[data-contact-access]');
      this.linkError = this.querySelector('[data-contact-link-error]');
      this.message = this.querySelector('[data-contact-message]');
      this.messageLabel = this.querySelector('[data-contact-message-label]');
      this.subject.addEventListener('change', () => this.updateFields(), options);
      this.link.addEventListener('input', () => this.validateLink(false), options);
      this.link.addEventListener('blur', () => this.validateLink(true), options);
      this.form.addEventListener('input', (event) => {
        if (event.target !== this.link && typeof event.target.setCustomValidity === 'function') {
          event.target.setCustomValidity('');
        }
      }, options);
      this.form.addEventListener('submit', (event) => {
        this.link.value = this.link.value.trim();
        this.orderInput.value = this.orderInput.value.trim();
        this.validateLink(true);
        this.form.querySelectorAll('input[required]:not([disabled]), textarea[required]:not([disabled])').forEach((field) => {
          if (field === this.link || field.type === 'checkbox') return;
          field.setCustomValidity(field.value.trim() ? '' : this.dataset.requiredError);
        });
        if (!this.form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.form.reportValidity();
        }
      }, { capture: true, signal: this.controller.signal });
      this.updateFields();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    updateFields() {
      const kind = this.subject.selectedOptions[0]?.dataset.kind || 'general';
      const isDesign = kind === 'design';
      const needsOrder = isDesign || kind === 'order';
      this.orderGroup.hidden = !needsOrder;
      this.designGroup.hidden = !isDesign;
      [[this.orderInput, needsOrder], [this.link, isDesign], [this.access, isDesign]].forEach(([field, active]) => {
        field.disabled = !active;
        field.required = active;
        field.setAttribute('aria-required', String(active));
        field.setCustomValidity('');
      });
      this.message.required = !isDesign;
      this.message.setAttribute('aria-required', String(!isDesign));
      this.message.setCustomValidity('');
      const messageText = isDesign ? this.dataset.messageOptional : this.dataset.messageLabel;
      this.message.placeholder = messageText;
      this.messageLabel.textContent = messageText;
      this.linkError.hidden = true;
      this.link.removeAttribute('aria-invalid');
      this.validateLink(false);
    }

    validateLink(showError) {
      if (this.link.disabled) {
        this.link.setCustomValidity('');
        return true;
      }
      const value = this.link.value.trim();
      const valid = !value || Boolean(window.DiaristDesignLink?.isValid(value));
      this.link.setCustomValidity(valid ? '' : this.dataset.linkError);
      const revealError = !valid && (showError || !this.linkError.hidden);
      this.linkError.hidden = !revealError;
      if (revealError) this.link.setAttribute('aria-invalid', 'true');
      else this.link.removeAttribute('aria-invalid');
      return valid;
    }
  }

  customElements.define('diarist-contact-form', DiaristContactForm);
})();
